<a routerLink="/empresa/contacto">
    <div class="row" id="encabezado_quiero_llamada">
        <div class="col-3 navbar_icon"><img src="/assets/icons/blue-icon-phone.png"></div>
        <div class="col-9"><span class="float-right">Le llamamos gratis</span></div>
    </div>
</a>